export default "__VITE_ASSET__CUZXd8Co__"